import { fuzzySearchResults } from './closestMatchOnKeyFuzzySearchHelpers';

function fullNameClosestMatchOnKeyName<
  T extends { key: string; value: string }
>(data: T[]): string {
  const fullNameMatchTerm = 'fullname';
  const firstNameMatchTerm = 'firstname';
  const lastNameMatchTerm = 'lastname';
  const backupMatchTerms = ['name'];

  const nameObject: {
    firstName?: string;
    lastName?: string;
  } = {};

  let fullNameMatch = data?.find(
    (x) => x.key.toLowerCase() === fullNameMatchTerm
  );
  if (!fullNameMatch) {
    fullNameMatch =
      fuzzySearchResults(fullNameMatchTerm, data, 50)[0]?.data ?? null;
  }

  if (fullNameMatch) {
    return fullNameMatch.value.toLowerCase();
  }

  let firstNameMatch = data?.find(
    (x) => x.key.toLowerCase() === firstNameMatchTerm
  );
  if (!firstNameMatch) {
    firstNameMatch =
      fuzzySearchResults(firstNameMatchTerm, data, 50)[0]?.data ?? null;
  }

  if (firstNameMatch) {
    nameObject.firstName = firstNameMatch.value;
  }

  let lastNameMatch = data?.find(
    (x) => x.key.toLowerCase() === lastNameMatchTerm
  );

  if (!lastNameMatch) {
    lastNameMatch =
      fuzzySearchResults(lastNameMatchTerm, data, 50)[0]?.data ?? null;
  }

  if (lastNameMatch) {
    nameObject.lastName = lastNameMatch.value;
  }

  if (nameObject.firstName && nameObject.lastName) {
    return (
      nameObject.firstName.toLowerCase() +
      ' ' +
      nameObject.lastName.toLowerCase()
    );
  } else {
    let backupMatch: string | undefined;
    backupMatchTerms.forEach((term) => {
      let matchedTerm = data?.find((x) => x.key.toLowerCase() === term);

      if (!matchedTerm) {
        matchedTerm = fuzzySearchResults(term, data, 50)[0]?.data ?? null;
      }

      if (matchedTerm) {
        backupMatch = matchedTerm.value.toLowerCase();
      }
    });

    return (
      backupMatch ??
      nameObject.firstName ??
      nameObject.lastName ??
      'Unknown Full Name'
    );
  }
}

export default fullNameClosestMatchOnKeyName;
